<template>
  <div v-if="error" class="error">
    <PageTitleComponent />
    <div class="error__block">
      <h1>{{ $t("error_title") }}</h1>
      <p>Code : {{ error.response.data.error }}</p>
      <p>Message : {{ error.response.data.message }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import PageTitleComponent from "@/components/PageTitleComponent.vue";
import { useMainStore } from "@/store";

export default {
  name: "GalleryView",
  components: { PageTitleComponent },
  data() {
    return {
      current: 0,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      error: (store) => store.error,
    }),
  },
};
</script>

<style lang="scss" scoped>
.error {
  &__block {
    position: fixed;
    background: rgba(255, 255, 255, 0.8);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 50px;
  }

  h1 {
    margin-bottom: 50px;
  }

  p {
    font-weight: 700;
    font-size: 20px;
  }
}
</style>
